import BaseModel from "./BaseModel";

export default class LearnDashUserModel extends BaseModel {
  private __email?: string;
  private __isEnroll?: boolean;
  private __learndashId?: string;
  private __password?: string;
  private __slug?: string;

  constructor(arg: any) {
    super(arg);
    this.__email = arg.email;
    this.__isEnroll = arg.is_enroll;
    this.__learndashId = arg.learndash_id;
    this.__password = arg.password;
    this.__slug = arg.slug;
  }

  get email() {
    return this.__email || "";
  }
  get isEnroll() {
    return this.__isEnroll || false;
  }
  get learndashId() {
    return this.__learndashId || "";
  }
  get password() {
    return this.__password || "";
  }
  get slug() {
    return this.__slug || "";
  }
}
